import Request from '@hotmart/request'
import { USER_INTENTION_REQUEST_IDENTIFIERS } from './constants'

Request.register(`${process.env.API_USER_INTENTION}`, {
  get: {
    [USER_INTENTION_REQUEST_IDENTIFIERS.GET_USER_INTENTION_QUALIFICATION]: '/userIntention/qualification'
  }
})
